<template>
  <el-row :gutter="12">
    <el-col :span="5">
      <div class="box1">
        <el-scrollbar>
          <div>
            <avue-tree :option="treeOption"
                       :data="treeData"
                       @node-click="nodeClick" />
          </div>
        </el-scrollbar>
      </div>
    </el-col>
    <el-col :span="19">
      <div class="nx-list-page system-user-customer-page">
        <avue-crud :option="option"
                   :search.sync="search"
                   :table-loading="loading"
                   :data="data"
                   ref="crud"
                   v-model="form"
                   :permission="permissionList"
                   @row-del="rowDel"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   :before-open="beforeOpen"
                   :page.sync="page"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="refreshChange"
                   @on-load="onLoad">
          <template slot="menuLeft">
            <el-button type="danger"
                       size="small"
                       icon="el-icon-delete"
                       v-if="permission.user_delete"
                       @click="handleDelete">删 除
            </el-button>
            <el-button type="info"
                       size="small"
                       plain
                       v-if="permission.user_role"
                       icon="el-icon-user"
                       @click="handleGrant">角色配置
            </el-button>
            <el-button type="info"
                       size="small"
                       plain
                       v-if="permission.user_reset"
                       icon="el-icon-refresh"
                       @click="handleReset">密码重置
            </el-button>
            <el-button type="info"
                       size="small"
                       plain
                       v-if="permission.user_unlock"
                       icon="el-icon-coordinate"
                       @click="handleLock">账号解封
            </el-button>
            <el-button type="success"
                       size="small"
                       plain
                       v-if="permission.user_import"
                       icon="el-icon-upload2"
                       @click="handleImport">导入
            </el-button>
            <el-button type="warning"
                       size="small"
                       plain
                       v-if="permission.user_export"
                       icon="el-icon-download"
                       @click="handleExport">导出
            </el-button>
          </template>
          <template slot-scope="{ row }"
                    slot="tenantName">
            <el-tag size="mini">{{ row.tenantName }}</el-tag>
          </template>
          <template slot-scope="{ row }"
                    slot="roleName">
            <el-tag size="mini">{{ row.roleName }}</el-tag>
          </template>
          <template slot-scope="{ row }"
                    slot="deptName">
            <el-tag size="mini">{{ row.deptName }}</el-tag>
          </template>
          <template slot-scope="{ row }"
                    slot="userTypeName">
            <el-tag size="mini">{{ row.userTypeName }}</el-tag>
          </template>
          <template slot-scope="{ row }"
                    slot="clientName">
            <el-tag v-for="(item, index) in row.userClients"
                    :key="index"
                    size="mini">{{
              item.clientName
            }}</el-tag>
          </template>
        </avue-crud>
        <el-dialog title="用户角色配置"
                   append-to-body
                   :visible.sync="roleBox"
                   width="345px"
                   :close-on-click-modal="false">
          <el-tree :data="roleGrantList"
                   show-checkbox
                   check-strictly
                   default-expand-all
                   node-key="id"
                   ref="treeRole"
                   :default-checked-keys="roleTreeObj"
                   :props="props">
          </el-tree>

          <span slot="footer"
                class="dialog-footer">
            <el-button @click="roleBox = false">取 消</el-button>
            <el-button type="primary"
                       @click="submitRole">提 交</el-button>
          </span>
        </el-dialog>
        <el-dialog title="用户数据导入"
                   append-to-body
                   :visible.sync="excelBox"
                   width="555px"
                   :close-on-click-modal="false">
          <avue-form :option="excelOption"
                     v-model="excelForm"
                     :upload-after="uploadAfter">
            <template slot="excelTemplate">
              <el-button type="primary"
                         @click="handleTemplate">
                点击下载<i class="el-icon-download el-icon--right"></i>
              </el-button>
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog title="用户平台配置"
                   append-to-body
                   :visible.sync="platformBox">
          <avue-crud :option="platformOption"
                     :table-loading="platformLoading"
                     :data="platformData"
                     ref="platformCrud"
                     v-model="platformForm"
                     :before-open="platformBeforeOpen"
                     :page.sync="platformPage"
                     :permission="platformPermissionList"
                     @row-update="platformRowUpdate"
                     @search-change="platformSearchChange"
                     @search-reset="platformSearchReset"
                     @selection-change="platformSelectionChange"
                     @current-change="platformCurrentChange"
                     @size-change="platformSizeChange"
                     @refresh-change="platformRefreshChange"
                     @on-load="platformOnLoad">
            <template slot-scope="{ row }"
                      slot="tenantName">
              <el-tag size="mini">{{ row.tenantName }}</el-tag>
            </template>
            <template slot-scope="{ row }"
                      slot="userTypeName">
              <el-tag size="mini">{{ row.userTypeName }}</el-tag>
            </template>
          </avue-crud>
        </el-dialog>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  getList,
  getUser,
  getUserPlatform,
  remove,
  updatePlatform,
  add,
  grant,
  resetPassword,
  unlock,
  getDefaultPassword,
} from '@/api/system/user'
import { exportBlob } from '@/api/common'
import { getDeptTree } from '@/api/system/dept'
import { getRoleTree } from '@/api/system/role'
import validator from '@/util/validate.js'
// import { getPostList } from '@/api/system/post'
import { mapGetters } from 'vuex'
import { getToken } from '@/util/auth'
import { downloadXls } from '@/util/util'
import { dateNow } from '@/util/date'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import func from '@/util/func'
import validate from '@/util/validate'
import crudMixins from '@/mixins/crud-mixins'

/** 与 produce PlatformTypeEnum.CUSTOM（client_custom）一致 */
const CLIENT_CUSTOM = 'client_custom'
/** 客户侧组织机构 dept_type */
const DEPT_TYPE_CUSTOM = 0

export default {
  name: 'UserCustomer',
  mixins: [crudMixins],
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {},
      search: {},
      roleBox: false,
      excelBox: false,
      platformBox: false,
      initFlag: true,
      selectionList: [],
      query: {},
      loading: true,
      platformLoading: false,
      defaultPassword: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        lazy: false,
        defaultExpandAll: true,
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children',
        },
      },
      option: {
        ...this.$store.state.publicOption,
        dialogDrag: false,
        height: 'auto',
        calcHeight: 80,
        tip: false,
        searchShow: true,
        searchMenuSpan: 24,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogType: 'drawer',
        dialogClickModal: false,
        column: [
          {
            label: '登录账号',
            prop: 'account',
            width: 140,
            overHidden: true,
            search: true,
            display: false,
          },
          {
            label: '用户姓名',
            prop: 'realName',
            width: 120,
            overHidden: true,
            display: false,
          },
          {
            label: '所属角色',
            prop: 'roleName',
            minWidth: 200,
            overHidden: true,
            slot: true,
            display: false,
          },
          /*{
            label: '所属角色',
            prop: 'roleId',
            type: 'tree',
            dicData: [],
            props: {
              label: 'title',
            },
            checkStrictly: true,
            hide: true,
            showColumn: false,
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },*/
          {
            label: '所属部门',
            prop: 'deptName',
            width: 130,
            overHidden: true,
            slot: true,
            display: false,
          },
          {
            label: '用户类别',
            type: 'select',
            dicUrl: '/api/blade-system/client/list',
            props: {
              label: 'clientName',
              value: 'clientId',
            },
            dicFormatter: (res) => {
              return res.data.records
            },
            search: false,
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
            slot: true,
            prop: 'clientId',
          },
          {
            label: '用户类别',
            prop: 'clientName',
            minWidth: 200,
            overHidden: true,
            slot: true,
            display: false,
          },
        ],
        group: [
          {
            label: '基础信息',
            prop: 'baseInfo',
            icon: 'el-icon-user-solid',
            column: [
              {
                label: '所属租户',
                prop: 'tenantId',
                type: 'input',
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                value: this.$store.state.user.tenantId,
                span: 8,
              },
              {
                label: '登录账号',
                prop: 'account',
                type: 'input',
                maxlength: 30,
                rules: [
                  {
                    required: true,
                    message: '请输入登录账号',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '用户类别',
                type: 'select',
                dicUrl: '/api/blade-system/client/list',
                props: {
                  label: 'clientName',
                  value: 'clientId',
                },
                dicFormatter: (res) => {
                  return res.data.records.filter(
                    (item) => item.clientId === CLIENT_CUSTOM
                  )
                },
                hide: true,
                editDisplay: false,
                viewDisplay: false,
                slot: true,
                prop: 'clientIdAdd',
                rules: [
                  {
                    required: true,
                    message: '请选择用户类别',
                    trigger: 'blur',
                  },
                ],
                disabled: true,
              },
              {
                label: '用户类别',
                type: 'select',
                dicUrl: '/api/blade-system/client/list',
                hide: true,
                viewDisplay: false,
                addDisplay: false,
                props: {
                  label: 'clientName',
                  value: 'clientId',
                },
                dicFormatter: (res) => {
                  return res.data.records.filter(
                    (item) => item.clientId === CLIENT_CUSTOM
                  )
                },
                slot: true,
                prop: 'clientId',
                // multiple: true,
                rules: [
                  {
                    required: true,
                  },
                ],
                disabled: true,
              },
              {
                label: '用户类别',
                prop: 'clientName',
                hide: true,
                editDisplay: false,
                addDisplay: false,
              },
              {
                label: '密码',
                prop: 'password',
                hide: true,
                editDisplay: false,
                viewDisplay: false,
                rules: [
                  {
                    required: true,
                    validator: validate.password,
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '确认密码',
                prop: 'password2',
                hide: true,
                editDisplay: false,
                viewDisplay: false,
                rules: [
                  { required: true, validator: validatePass2, trigger: 'blur' },
                ],
              },
            ],
          },
          {
            label: '详细信息',
            prop: 'detailInfo',
            icon: 'el-icon-s-order',
            column: [
              {
                label: '用户昵称',
                prop: 'name',
                type: 'input',
                hide: true,
                maxlength: 20,
                rules: [
                  {
                    required: true,
                    message: '请输入用户昵称',
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '用户姓名',
                prop: 'realName',
                rules: [
                  {
                    required: true,
                    message: '请输入用户姓名',
                    trigger: 'blur',
                  },
                  {
                    min: 2,
                    max: 5,
                    message: '姓名长度在2到5个字符',
                  },
                ],
              },
              {
                label: '手机号码',
                prop: 'phone',
                overHidden: true,
                maxlength: 11,
                rules: [
                  {
                    required: false,
                    validator: validator.notRequiredPhone,
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '电子邮箱',
                prop: 'email',
                hide: true,
                overHidden: true,
                rules: [
                  {
                    required: false,
                    validator: validator.notRequiredEmail,
                    trigger: 'blur',
                  },
                ],
              },
              {
                label: '用户性别',
                prop: 'sex',
                type: 'select',
                dicData: [
                  {
                    label: '男',
                    value: 1,
                  },
                  {
                    label: '女',
                    value: 2,
                  },
                  {
                    label: '未知',
                    value: 3,
                  },
                ],
                hide: true,
              },
              {
                label: '用户生日',
                type: 'date',
                prop: 'birthday',
                format: 'yyyy-MM-dd hh:mm:ss',
                valueFormat: 'yyyy-MM-dd hh:mm:ss',
                hide: true,
                pickerOptions: {
                  disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e7
                  },
                },
              },
              {
                label: '账号状态',
                prop: 'statusName',
                hide: true,
                display: false,
              },
            ],
          },
          {
            label: '职责信息',
            prop: 'dutyInfo',
            icon: 'el-icon-s-custom',
            column: [
              {
                label: '用户编号',
                prop: 'code',
                maxlength: 10,
              },
              {
                label: '所属角色',
                prop: 'roleId',
                multiple: true,
                type: 'tree',
                dicData: [],
                props: {
                  label: 'title',
                },
                checkStrictly: true,
                slot: true,
                rules: [
                  {
                    required: true,
                    message: '请选择所属角色',
                    trigger: 'click',
                  },
                ],
              },
              {
                label: '所属客户',
                prop: 'deptId',
                type: 'tree',
                dicData: [],
                props: {
                  label: 'title',
                },
                checkStrictly: true,
                slot: true,
                rules: [
                  {
                    required: true,
                    message: '请选择所属客户',
                    trigger: 'click',
                  },
                ],
              },
              // {
              //   label: "所属岗位",
              //   prop: "postId",
              //   type: "tree",
              //   multiple: true,
              //   dicData: [],
              //   props: {
              //     label: "postName",
              //     value: "id"
              //   },
              //   rules: [{
              //     required: true,
              //     message: "请选择所属岗位",
              //     trigger: "click"
              //   }],
              // },
            ],
          },
        ],
      },
      data: [],
      platformQuery: {},
      platformSelectionList: [],
      platformData: [],
      platformForm: {},
      platformOption: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogClickModal: false,
        menuWidth: 120,
        editBtnText: '配置',
        column: [
          {
            label: '登录账号',
            prop: 'account',
            search: true,
            display: false,
          },
          {
            label: '用户姓名',
            prop: 'realName',
            search: true,
            display: false,
          },
          {
            label: '用户拓展',
            prop: 'userExt',
            type: 'textarea',
            minRows: 8,
            span: 24,
            overHidden: true,
            row: true,
            hide: true,
          },
        ],
      },
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '文件上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '文件上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/blade-user/import-user',
          },
          {
            label: '数据覆盖',
            prop: 'isCovered',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: '否',
                value: 0,
              },
              {
                label: '是',
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: '请选择是否覆盖',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '模板下载',
            prop: 'excelTemplate',
            formslot: true,
            span: 24,
          },
        ],
      },
    }
  },
  watch: {
    'excelForm.isCovered'() {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, 'excelFile')
        column.action = `/api/blade-user/import-user?isCovered=${this.excelForm.isCovered}`
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.user_add, false),
        viewBtn: this.vaildData(this.permission.user_view, false),
        delBtn: this.vaildData(this.permission.user_delete, false),
        editBtn: this.vaildData(this.permission.user_edit, false),
      }
    },
    platformPermissionList() {
      return {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: this.vaildData(this.permission.user_edit, false),
      }
    },
    ids() {
      let ids = []
      this.selectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids.join(',')
    },
  },
  mounted() {
    this.initData()
    this.$nextTick(() => {
      this.getTableHeightEvent && this.getTableHeightEvent()
    })
  },
  methods: {
    nodeClick(data) {
      this.treeDeptId = data.id
      this.page.currentPage = 1
      this.onLoad(this.page)
    },
    initData() {
      getRoleTree(CLIENT_CUSTOM).then((res) => {
        const column = this.findObject(this.option.group, 'roleId')
        //const columnList = this.findObject(this.option.column, 'roleId')
        column.dicData = res.data.data
        //columnList.dicData = res.data.data
      })
      getDeptTree({
        deptType: DEPT_TYPE_CUSTOM,
        showIs: 0,
      }).then((res) => {
        const list = res.data.data || []
        this.treeData = list
        const column = this.findObject(this.option.group, 'deptId')
        column.dicData = list
      })
      getDefaultPassword().then((res) => {
        this.defaultPassword = res.data.data
        console.log('*******' + this.defaultPassword)
      })
      // getPostList().then((res) => {
      //   const column = this.findObject(this.option.group, 'postId')
      //   column.dicData = res.data.data
      // })
    },
    submitRole() {
      const roleList = this.$refs.treeRole.getCheckedKeys().join(',')
      grant(this.ids, roleList).then(() => {
        this.roleBox = false
        this.$message({
          type: 'success',
          message: '操作成功!',
        })
        this.onLoad(this.page)
      })
    },
    rowSave(row, done, loading) {
      // row.deptId = row.deptId.join(",");
      row.roleId = row.roleId.join(',')
      // row.postId = row.postId.join(",");
      row.clientId = row.clientIdAdd
      row.tenantId = row.tenantId || this.$store.state.user.tenantId
      add(row).then(
        () => {
          this.initFlag = false
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          done()
        },
        (error) => {
          window.console.log(error)
          loading()
        }
      )
    },
    rowUpdate(row, index, done, loading) {
      // row.deptId = row.deptId.join(",");
      row.roleId = row.roleId.join(',')
      // row.postId = row.postId.join(",");
      // row.clientId = row.clientId.join(",");
      add(row).then(
        () => {
          this.initFlag = false
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          done()
        },
        (error) => {
          window.console.log(error)
          loading()
        }
      )
    },
    rowDel(row) {
      this.$confirm_danger('删除')
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
    },
    searchReset() {
      this.query = {}
      this.treeDeptId = ''
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm_danger('删除')
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.$refs.crud.toggleSelection()
        })
    },
    handleReset() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm(
        `确定将选择账号密码重置为${this.defaultPassword}`,
        '提示信息',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          return resetPassword(this.ids)
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.$refs.crud.toggleSelection()
        })
    },
    handleGrant() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.roleTreeObj = []
      if (this.selectionList.length === 1) {
        this.roleTreeObj = this.selectionList[0].roleId.split(',')
      }
      getRoleTree(CLIENT_CUSTOM).then((res) => {
        this.roleGrantList = res.data.data
        this.roleBox = true
      })
    },
    handlePlatform() {
      this.platformBox = true
    },
    handleLock() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm_primary('解封')
        .then(() => {
          return unlock(this.ids)
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
    },
    handleImport() {
      this.excelBox = true
    },
    uploadAfter(res, done, loading, column) {
      window.console.log(column)
      this.excelBox = false
      this.refreshChange()
      done()
    },
    handleExport() {
      const account = func.toStr(this.search.account)
      const realName = func.toStr(this.search.realName)
      this.$confirm('是否导出用户数据?', '提示信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        NProgress.start()
        exportBlob(
          `/api/blade-user/export-user?${
            this.website.tokenHeader
          }=${getToken()}&account=${account}&realName=${realName}`
        ).then((res) => {
          downloadXls(res.data, `客户账号数据${dateNow()}.xlsx`)
          NProgress.done()
        })
      })
    },
    handleTemplate() {
      exportBlob(
        `/api/blade-user/export-template?${
          this.website.tokenHeader
        }=${getToken()}`
      ).then((res) => {
        downloadXls(res.data, '用户数据模板.xlsx')
      })
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getUser(this.form.id).then((res) => {
          const { clientId, clientName } = res.data.data.userClients[0] || {}
          this.form = {
            ...res.data.data,
            clientId,
            clientName: type === 'view' ? clientName : null,
          }
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = this.form.deptId
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = this.form.roleId.split(',')
          }
          // if (this.form.hasOwnProperty("postId")) {
          //   this.form.postId = this.form.postId.split(",");
          // }
        })
      }
      if (type === 'add') {
        this.form.clientIdAdd = CLIENT_CUSTOM
        this.form.tenantId = this.$store.state.user.tenantId
      }
      this.initFlag = true
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign({ clientId: CLIENT_CUSTOM }, params, this.query),
        this.treeDeptId
      ).then((res) => {
        const data = res.data.data
        this.page.total = data.total
        this.data = data.records
        this.loading = false
        this.selectionClear()
        this.$nextTick(() => {
          this.getTableHeightEvent && this.getTableHeightEvent()
        })
      })
    },
    platformRowUpdate(row, index, done, loading) {
      updatePlatform(row.id, row.userType, row.userExt).then(
        () => {
          this.platformOnLoad(this.platformPage)
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          done()
        },
        (error) => {
          window.console.log(error)
          loading()
        }
      )
    },
    platformBeforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getUserPlatform(this.platformForm.id).then((res) => {
          this.platformForm = res.data.data
        })
      }
      done()
    },
    platformSearchReset() {
      this.platformQuery = {}
      this.platformOnLoad(this.platformPage)
    },
    platformSearchChange(params, done) {
      this.platformQuery = params
      this.platformPage.currentPage = 1
      this.platformOnLoad(this.platformPage, params)
      done()
    },
    platformSelectionChange(list) {
      this.platformSelectionList = list
    },
    platformSelectionClear() {
      this.platformSelectionList = []
      this.$refs.platformCrud.toggleSelection()
    },
    platformCurrentChange(currentPage) {
      this.platformPage.currentPage = currentPage
    },
    platformSizeChange(pageSize) {
      this.platformPage.pageSize = pageSize
    },
    platformRefreshChange() {
      this.platformOnLoad(this.platformPage, this.platformQuery)
    },
    platformOnLoad(page, params = {}) {
      this.platformLoading = true
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign({ clientId: CLIENT_CUSTOM }, params, this.query),
        this.treeDeptId
      ).then((res) => {
        const data = res.data.data
        this.platformPage.total = data.total
        this.platformData = data.records
        this.platformLoading = false
        this.selectionClear()
      })
    },
  },
}
</script>

<style scoped>
.box1 {
  max-height: calc(100vh - 180px);
  min-height: 280px;
}

.el-scrollbar {
  height: 100%;
}

.box1 .el-scrollbar__wrap {
  overflow: scroll;
}

.system-user-customer-page ::v-deep .avue-crud__search {
  padding-top: 6px;
  padding-bottom: 6px;
}

.system-user-customer-page ::v-deep .avue-crud__search .el-form-item {
  margin-bottom: 8px;
}

.system-user-customer-page ::v-deep .avue-crud__menu {
  margin-top: 0;
  margin-bottom: 8px;
  min-height: auto;
}

.dialog-footer {
  text-align: right;
  padding: 5px;
}
</style>
